import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import {
  RightsizingHpaSettings,
  WorkloadDetailsContext,
} from '@cast/split-me/features/cluster/workload-optimization';

import { WORKLOAD_VIEWS } from '../../_constants';

export const InventoryWorkloadHorizontalAutoscaling = () => {
  const { workload } = useContext(WorkloadDetailsContext);

  if (!workload) {
    return null;
  }

  if (workload.verticalScalingPolicy?.isCastware) {
    return (
      <Navigate to={`../${WORKLOAD_VIEWS.VERTICAL_AUTOSCALING}`} replace />
    );
  }

  return <RightsizingHpaSettings workload={workload} />;
};
